<template lang="pug">
  .page-configuration.row.column
    accordion
      accordion-item(v-for="(section, i) in conf", :title="i")
        configuration-item(v-for="(c, ic) in section", :item="c", :itemKey="ic", @updateItem="updateItem")

</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

import Accordion from 'components/structure/foundation/Accordion/Accordion'
import AccordionItem from 'components/structure/foundation/Accordion/AccordionItem'
import ConfigurationItem from '../../components/backoffice/ConfigurationItem'
import MaggieHelper from '../../maggieHelper'

export default {
  name: 'Configuration',
  components: {
    ConfigurationItem,
    Accordion,
    AccordionItem
  },
  data() {
    return {
      conf: null,
    }
  },

  created() {
    KeplerBackofficeSdk.configuration.get((data) => {
      this.conf = data
    })
  },
  methods: {
    updateItem(key, value) {
      MaggieHelper.notification('Updating', 'Update sent', 'info')

      KeplerBackofficeSdk.configuration.update(key, value, (data) => {
          this.$store.dispatch('getConfiguration', true).then(() => {
            MaggieHelper.notification('Updated', 'Configuration updated', 'success')
          })
        }, (e) => {
          MaggieHelper.notification(e.result, e.result_code, 'alert')
        }
      )
    },
  },
  computed: {}
}
</script>
<style lang="sass" rel="stylesheet/sass">
.page-configuration
  .accordion-title
    text-transform: uppercase

  //select
    padding: 0
    height: 2.3125rem
</style>



// WEBPACK FOOTER //
// Configuration.vue?0720ae30